import { render, staticRenderFns } from "./TasksTable.vue?vue&type=template&id=18260aa7&scoped=true"
import script from "./TasksTable.vue?vue&type=script&lang=ts"
export * from "./TasksTable.vue?vue&type=script&lang=ts"
import style0 from "./TasksTable.vue?vue&type=style&index=0&id=18260aa7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18260aa7",
  null
  
)

export default component.exports